import { render, staticRenderFns } from "./AbnormalData.vue?vue&type=template&id=ef5961a2"
import script from "./AbnormalData.vue?vue&type=script&lang=js"
export * from "./AbnormalData.vue?vue&type=script&lang=js"
import style0 from "./AbnormalData.vue?vue&type=style&index=0&id=ef5961a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports